import { IPage } from '@types'
import Layout from 'components/layouts/Layout'
import { generateStaticProps } from 'lib/generateStaticProps'
import { isAbsent, isPresent } from 'lib/utils'
import {
  GetStaticPaths,
  GetStaticPropsContext,
  InferGetStaticPropsType,
} from 'next'

export let getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export let getStaticProps = async (ctx: GetStaticPropsContext) =>
  await generateStaticProps(ctx)

export type AnyPageProps = InferGetStaticPropsType<
  typeof getStaticProps
>

let AnyPage: IPage<AnyPageProps> = ({ content }) => {
  if (isAbsent(content)) return null

  return (
    <main className='custom-px mb-12 bg-white flex-grow'>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </main>
  )
}

AnyPage.getLayout = (page: { props: AnyPageProps }) => (
  <Layout
    menus={page.props?.menus}
    index={isPresent(page.props.content)}
    title={page.props?.title}
    description={page.props?.description}
    keywords={page.props?.keywords}
  >
    {page}
  </Layout>
)

export default AnyPage
